import { render } from "./WeeklyReport.vue?vue&type=template&id=2523e58e&scoped=true&ts=true"
import script from "./WeeklyReport.vue?vue&type=script&lang=ts"
export * from "./WeeklyReport.vue?vue&type=script&lang=ts"

import "@/assets/scss/report-grid.scss?vue&type=style&index=0&id=2523e58e&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2523e58e"]])

export default __exports__